<template>
    <modal
        :title="data.title"
        @closeModal="$emit('closeModal')">
        <div class="modal__body-content">
            <div class="grid">
                <div
                    v-for="(item, index) in data.content"
                    :key="`modal-content-${index}`"
                    class="grid__item"
                    :class="(data.content.length > 1) ? 'desktop--6' : ''">

                    <div v-if="item.picture">
                        <div class="grid">
                            <div class="grid__item small--3">
                                <img
                                    :src="require(`@/assets/images/${item.picture}`)"
                                    alt="" />
                            </div>
                            <div
                                class="grid__item small--9">
                                <h2 v-if="item.title">{{ item.title }}</h2>
                                <div v-html="item.body"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <h2 v-if="item.title">{{ item.title }}</h2>
                        <div v-html="item.body"></div>
                    </div>

                </div>
            </div>
        </div>
    </modal>
</template>

<script>
// @ is an alias to /src

import Modal from "@/components/modals/Modal.vue";

export default {
    name: "HelpModal",
    components: {
        Modal: Modal
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    }
};
</script>